import { Network } from '@capacitor/network';
import { isNative } from '../native/platform.js';
import { showNotice, hideNotice } from './notice.js';

/**
 * Connectivity indicator.
 *
 * A gym basement is the app's core environment, so going offline has to be a
 * visible, understood state rather than a screen full of silently failed
 * requests. Workouts already persist to local storage while active, so the
 * message tells the user what still works.
 */

let online = true;

function render() {
  if (online) {
    hideNotice();
    document.body.classList.remove('is-offline');
  } else {
    document.body.classList.add('is-offline');
    showNotice({
      message: "You're offline — workouts are saved on this device and will sync later.",
      variant: 'offline',
    });
  }
}

function setOnline(next) {
  if (next === online) return;
  online = next;
  render();
}

export async function installConnectivity() {
  if (isNative) {
    // `navigator.onLine` is unreliable inside a web view; the platform's own
    // reachability check is not.
    try {
      const status = await Network.getStatus();
      online = status.connected;
      Network.addListener('networkStatusChange', (s) => setOnline(s.connected));
    } catch (err) {
      console.warn('[ironpact] network status unavailable', err);
    }
  } else {
    online = navigator.onLine;
    window.addEventListener('online', () => setOnline(true));
    window.addEventListener('offline', () => setOnline(false));
  }

  render();
}

/** Current connectivity, for callers that need to branch before a request. */
export function isOnline() {
  return online;
}
